import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  createNewItemLink,
  createNewItemLinkFn,
  item_createNewSurvey,
  item_createNewSurveyFn,
  updateSurvey as updateSurveyProvider,
  updateSurveyFn as updateSurveyProviderFn,
} from 'store/providers/providerSlice';
import Button from '../../../../Button';
import messages from './Messages';
import React, { useEffect, useState } from 'react';
import LoadingCircleIndicator from '../../../../LoadingCircleIndicator';
import Select from '../../../../Select';
import { IOption } from 'components/Select/Select';
import cloneDeep from 'lodash/cloneDeep';
import { appDispatch, RootState } from 'store/store';
import {
  ISurveyItem,
  SURVEY_ANALYSE_LINK_DESC_NAME,
  ISurveyItemWithData,
  ISurveyView,
  IQuestionsView,
  IMultipleChoiceQuestionView,
} from 'store/survey/surveyTypes';
import {
  IProvider,
  IProviderItems,
  IProviderItemView,
} from 'store/providers/providerTypes';
import {
  addQuestion,
  addQuestionFn,
  requireSurvey,
  requireSurveyFn,
  updateSurvey,
  updateSurveyFn,
} from 'store/survey/surveySlice';
import i18n from '../../../../../i18n';

interface IOwnProps {
  surveyItem: ISurveyItem;
  templateItem: ISurveyItemWithData;
  provider: IProvider;
}

interface IStateToProps {
  survey: ISurveyView;
  templateSurvey?: ISurveyView;
  providerItems: IProviderItems['items'];
  hospitalTagId?: number;
}
interface IDispatchToProps {
  createProviderSurvey: (
    item: IProviderItemView
  ) => ReturnType<typeof item_createNewSurveyFn>;
  updateSurvey: (
    surveyData: ISurveyView,
    providerSurveyItemData: ISurveyItem
  ) => ReturnType<typeof updateSurveyFn>;
  addQuestion: (
    questionData: IQuestionsView,
    providerSurveyData: ISurveyItem,
    keepQuestionId: boolean
  ) => ReturnType<typeof addQuestionFn>;
  requireSurvey: (
    surveyItem: ISurveyItem,
    forceReload?: boolean
  ) => ReturnType<typeof requireSurveyFn>;
  addLink: (
    sourceItemId: number,
    destinationItemId: number,
    description: string
  ) => ReturnType<typeof createNewItemLinkFn>;
  updateProviderSurvey: (
    surveyItem: ISurveyItemWithData
  ) => ReturnType<typeof updateSurveyProviderFn>;
}

type ICompontentProps = IOwnProps & IDispatchToProps & IStateToProps;
const CreateAnalyseItem: React.FC<ICompontentProps> = ({
  templateItem,
  surveyItem,
  createProviderSurvey,
  updateSurvey,
  survey,
  templateSurvey,
  requireSurvey,
  addLink,
  addQuestion,
  hospitalTagId,
}) => {
  const periodType = [
    { value: 'none', label: i18n.t('disabled', { ns: 'survey' }) as string },
    { value: 'day', label: i18n.t('day', { ns: 'survey' }) as string },
    { value: 'week', label: i18n.t('week', { ns: 'survey' }) as string },
    { value: 'month', label: i18n.t('month', { ns: 'survey' }) as string },
    { value: 'season', label: i18n.t('season', { ns: 'survey' }) as string },
    {
      value: 'twoSeason',
      label: i18n.t('twoSeason', { ns: 'survey' }) as string,
    },
    { value: 'year', label: i18n.t('year', { ns: 'survey' }) as string },
  ];
  const [loadingSurvey, setLoadingSurvey] = useState(false);
  const [creating, setCreating] = useState(false);
  const [selectedPeriodType, setSelectedPeriodType] = useState(
    survey.periodType
  );

  const [distinctiveType, setDistinctiveType] = useState({});
  useEffect(() => {
    setLoadingSurvey(true);
    if (!templateSurvey) {
      requireSurvey(templateItem.data).then(() => {
        setLoadingSurvey(false);
      });
    }
    setLoadingSurvey(false);
  }, [templateItem]);

  useEffect(() => {
    if (templateSurvey && templateSurvey.periodType !== 'none') {
      setSelectedPeriodType(templateSurvey.periodType);
    }
  }, [templateSurvey]);
  if (loadingSurvey) return <LoadingCircleIndicator />;
  function createAnalyseSurvey() {
    setCreating(true);
    createProviderSurvey({
      ...templateItem.data,
      dadId: surveyItem.dadId,
      id: undefined as any,
      name: messages.analyse + ' - ' + surveyItem.name,
      hidden: true,
    }).then(async (response: any) => {
      const surveyData = { ...templateSurvey! };
      const analyseItemObj = response.payload.remoteItem as ISurveyItem;
      surveyData.id = analyseItemObj.surveyId;
      surveyData.name = analyseItemObj.name;
      surveyData.periodType = selectedPeriodType;
      await updateSurvey(surveyData, analyseItemObj);
      await addLink(
        surveyItem.id,
        analyseItemObj.id,
        SURVEY_ANALYSE_LINK_DESC_NAME
      );
      for (const { data: q } of Object.values(
        templateSurvey!.questionMap || {}
      ).sort((a, b) => a.data.order - b.data.order)) {
        if (!q.deleted) await addQuestion(q, analyseItemObj, true);
      }
      for (const { data: q } of Object.values(survey.questionMap || {}).sort(
        (a, b) => a.data.order - b.data.order
      )) {
        if (q.distinctive && !q.deleted && distinctiveType[q.id] !== 'total') {
          const clone = cloneDeep(q) as IMultipleChoiceQuestionView;
          if (distinctiveType[q.id] === 'both' && hospitalTagId)
            clone.tagChoices = [...(clone.tagChoices ?? []), hospitalTagId];
          await addQuestion(clone, analyseItemObj, true);
        }
      }
      await requireSurvey(analyseItemObj, true);
      setCreating(false);
    });
  }
  const surveyPeriodIndex =
    periodType.findIndex((it) => it.value === survey.periodType) || 0;

  const questionIncludeOptions: IOption[] = [
    {
      label: 'ایجاد تفکیک تحلیل',
      value: 'default',
    },
    {
      label: 'ایجاد تفکیک و تحلیل کل',
      value: 'both',
    },
    {
      label: 'صرف نظر کردن از تفکیک تحلیل',
      value: 'total',
    },
  ];
  if (!hospitalTagId) {
    questionIncludeOptions.splice(1, 1);
  }
  return (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        gap: '40px',
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
    >
      <div>
        {Object.values(survey.questionMap || {})
          .filter((q) => !q.data.deleted && q.data.distinctive)
          .sort((a, b) => a.data.order - b.data.order)
          .map((q) => {
            return (
              <Select
                allowRemove={false}
                label={q.data.title}
                key={q.data.id}
                onChangeValues={(values) => {
                  const newVal = { ...distinctiveType };
                  newVal[q.data.id] = values[0].value;
                  return setDistinctiveType(newVal);
                }}
                values={questionIncludeOptions.filter(
                  (it) => it.value === (distinctiveType[q.data.id] ?? 'default')
                )}
                options={questionIncludeOptions}
              />
            );
          })}
      </div>
      <Select
        containerStyle={{ width: '200px' }}
        options={periodType.filter((_, index) => index >= surveyPeriodIndex)}
        isRequired={true}
        allowRemove={false}
        values={periodType.filter((it) => it.value === selectedPeriodType)}
        onChangeValues={(fieldOption) => {
          setSelectedPeriodType(fieldOption[0].value as any);
        }}
        label={messages.analysePeriod}
      />
      <Button color={'green'} loading={creating} onClick={createAnalyseSurvey}>
        {messages.createAnalyseForm}
      </Button>
      {/*<Button
        color={'green'}
        loading={creating}
        onClick={() => {
          setShowLinkModal(true);
        }}
      >
        {messages.linkAnalyse}
      </Button>*/}
      {/*{selectedToLinkAnalyse && <Badge>{selectedToLinkAnalyse.title}</Badge>}*/}
      {/*<Button*/}
      {/*  loading={creating}*/}
      {/*  disabled={!selectedToLinkAnalyse}*/}
      {/*  onClick={doLink}*/}
      {/*>*/}
      {/*  {messages.save}*/}
      {/*</Button>*/}
      {/*
      {showLinkModal && (
        <TaskFileExplorerModal
          onClose={() => {
            setShowLinkModal(false);
          }}
          onSave={(item: any) => {
            if (item.id === surveyItem.id)
              notify(messages.invalidAnalyseItem, 'error');
            else {
              setSelectedToLinkAnalyse(item);
              setShowLinkModal(false);
            }
          }}
          providers={relatedProviders}
          defaultItem={{
            id: surveyItem.id,
            type: 'survey',
            providerId: surveyItem.providerId,
            title: surveyItem.name,
          }}
        />
      )}
*/}
    </div>
  );
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const templateSurvey =
    state.survey.data[props.templateItem.data.surveyId]?.data;
  const survey = state.survey.data[props.surveyItem.surveyId].data;
  const hospitalTagIdTmp = Object.values(
    state.providers.tags[props.surveyItem.providerId]!.data!
  ).find((it) => it.text === 'بیمارستان')?.id;
  const hospitalTagId = hospitalTagIdTmp ? Number(hospitalTagIdTmp) : undefined;

  const providerItems = state.providers.items[props.provider.id].items;

  return {
    survey,
    templateSurvey,
    providerItems,
    hospitalTagId,
  };
};
const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = (
  _,
  ownProps
) => {
  return {
    createProviderSurvey: (item: IProviderItemView) => {
      return appDispatch(item_createNewSurvey({ item }));
    },
    requireSurvey: (providerSurveyItemData: ISurveyItem, force?: boolean) =>
      appDispatch(
        requireSurvey({ providerSurveyItemData, forceReload: force })
      ),
    updateSurvey: (
      surveyData: ISurveyView,
      providerSurveyItemData: ISurveyItem
    ) => appDispatch(updateSurvey({ surveyData, providerSurveyItemData })),

    updateProviderSurvey: (surveyItem: ISurveyItemWithData) =>
      appDispatch(updateSurveyProvider({ item: surveyItem.data })),
    addQuestion: (
      questionData: IQuestionsView,
      surveyData: ISurveyItem,
      keepQuestionId: boolean
    ) =>
      appDispatch(
        addQuestion({
          questionData,
          providerSurveyData: surveyData,
          keepQuestionId,
        })
      ),
    addLink: (
      sourceItemId: number,
      destinationItemId: number,
      description: string
    ) =>
      appDispatch(
        createNewItemLink({
          sourceItemId,
          destinationItemId,
          description,
          tempItemId: null,
          providerId: ownProps.surveyItem.providerId,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAnalyseItem);
